import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { subscribe } from '../../actions/subscribe';
import { unsubscribe } from '../../actions/unsubscribe';
import messages, { CATEGORY_SUBSCRIBED, CATEGORY_UNSUBSCRIBED } from '../../components/message/messages';
import { SubscribeIcon } from '../../components/icons';
import ActionButton from '../../components/action-button';
import withEnvironment from '../../hoc/with-environment';
import withPermissions from '../../hoc/with-permissions';
import withTranslate from '../../hoc/with-translate';
import withAuth from '../../hoc/with-auth';

export class CategoryActions extends Component {
  handleSubscribe = () => {
    const { category: { _id }, subscribe, showMessage } = this.props;
    return subscribe({ _id, type: 'category' }).then(() =>
      showMessage(messages[CATEGORY_SUBSCRIBED].content(), messages[CATEGORY_SUBSCRIBED].type)
    );
  };

  handleUnsubscribe = () => {
    const { category: { _id }, unsubscribe, showMessage } = this.props;
    return unsubscribe({ _id, type: 'category' }).then(() =>
      showMessage(messages[CATEGORY_UNSUBSCRIBED].content(), messages[CATEGORY_UNSUBSCRIBED].type)
    );
  };

  render() {
    const { canRender, category, t, forPublicUser } = this.props;
    const followButton = canRender('subscribe', 'category', category, can => {
      const action = category.isSubscribed ? this.handleUnsubscribe : this.handleSubscribe;
      return (
        <ActionButton
          data-hook="category-actions__subscriptions"
          onClick={can ? action : forPublicUser(action)}
        >
          <SubscribeIcon className="forum-icon-fill"/>
          {t(category.isSubscribed ? 'category-actions.unsubscribe-category' : 'category-actions.subscribe-category')}
        </ActionButton>
      );
    });

    return <div>{followButton}</div>;
  }
}

CategoryActions.propTypes = {
  category: PropTypes.object.isRequired,
  openModal: PropTypes.func.isRequired,
  showMessage: PropTypes.func.isRequired,
  subscribe: PropTypes.func.isRequired,
  unsubscribe: PropTypes.func.isRequired,
  canRender: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  forPublicUser: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  subscribe,
  unsubscribe,
};

// prettier-ignore
export default flowRight(
  connect(undefined, mapDispatchToProps),
  withEnvironment({ showMessage: 'showMessage' }),
  withPermissions,
  withTranslate,
  withAuth,
)(CategoryActions);



// WEBPACK FOOTER //
// ./app/containers/category-actions/category-actions.js